import { SUBSCRIPTIONS_CUSTOMER_SCOOP_CONTROLLER_ROOT_PATH } from "./root";

export const SUBSCRIPTIONS_CUSTOMER_ADD_SCOOP_PATH_SUFFIX = "/add";
/** /customer/subscription/scoop/add */
export const SUBSCRIPTIONS_CUSTOMER_ADD_SCOOP_PATH = `${
  SUBSCRIPTIONS_CUSTOMER_SCOOP_CONTROLLER_ROOT_PATH
}${
  SUBSCRIPTIONS_CUSTOMER_ADD_SCOOP_PATH_SUFFIX
}`;
